import Vue from 'vue'
import router from '@/router/index.js'
import store from '@/store/index.js'
import axios from 'axios'
import App from './App.vue'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import {configureAxios} from '@/http.js'

// Axios defaults (timeout, CSRF, auth token) + request/response interceptors.
// Extracted to @/http.js so the timeout and error handling are unit-testable
// without mounting the app. See IT-771.
configureAxios(axios, store)

Vue.config.productionTip = false

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App),
}).$mount('#app')
